import Contract from "slotworks/utils/contracts/contract";
import Layers from "slotworks/graphics/layers/layers";
import { Emitter } from "pixi-particles";
import {SGLayers} from "sg-consts";

class SGBackgroundParticles {
    private particleEmitter: Emitter;
    private static PARTICLES_ID: string = "sandstorm_particles";

    public init(): void {
        this.particleEmitter = Layers.Custom.get(SGLayers.Sand).getParticle(SGBackgroundParticles.PARTICLES_ID)
        this.particleEmitter.emit = false;
    }

    //Start sandstorm particle and return contract because could have async events when start
    public startSandStorm(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.particleEmitter.emit = true;
            resolve();
        });
    }

    //Stop sandstorm particle and return contract because could have async fadeout
    public stopSandStorm(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.particleEmitter.emit = false;
            resolve();
        });
    }
}

export default new SGBackgroundParticles();
